module.exports = __webpack_public_path__ + "img/7.1d2df403.svg";